import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import snack from "./snack.module";

import selectsData from "./selectsData.module";
import displayPreferences from "./displayPreferences.module";
import companyContact from "./companyContact.module";
import tagCategory from "./tagCategory.module";
import vendorOffer from "./vendorOffer.module";
import vendorOfferSet from "./vendorOfferSet.module";
import vendorOfferSetImportType from "./vendorOfferSetImportType.module";
import emailOffer from "./emailOffer.module";
import validationRule from "./validationRule.module";
import tagCategoryType from "./tagCategoryType.module";
import quickOffer from "./quickOffer.module";
import users from "./users.module";
import teams from "./teams.module";
import userFilter from "./userFilter.module";
import aliases from "./aliases.module";
import mappings from "./mappings.module";
import mappingValues from "./mappingValues.module";
import incoterms from "./incoterms.module";
import countries from "./countries.module";
import transportData from "./transportData.module";
import liveList from "./liveList.module";
import priceLists from "./priceLists.module";
import pricing from "./pricing.module";
import unit_conversions from "./unit_conversions.module";
import price_config from "./price_config.module";
import companies from "./companies.module";
import organizations from "./organizations.module";
import pipelines from "./pipelines.module";
import deals from "./deals.module";
import dealCustomerRequests from "./deals/dealCustomerRequests.module";
import dealStatuses from "./dealStatuses.module";
import dealDocumentTypes from "./dealDocumentTypes.module";
import dealTypes from "./dealTypes.module";
import fieldTagTypes from "./fieldTagTypes.module";
import fieldTags from "./fieldTags.module";
import stockContext from "./stock/stockContext.module";
import stockWarehouses from "./stock/stockWarehouses.module";
import stockProducts from "./stock/stockProducts.module";
import stockProductCategories from "./stock/stockProductCategories.module";
import stockProductDepartments from "./stock/stockProductDepartments.module";
import stockPackagings from "./stock/stockPackagings.module";
import stockUnits from "./stock/stockUnits.module";
import stockInventory from "./stock/stockInventory.module";
import stockDashboard from "./stock/stockDashboard.module";
import stockQualityHolds from "./stock/stockQualityHolds.module";
import stockAverageCosts from "./stock/stockAverageCosts.module";
import stockPurchaseOrders from "./stock/stockPurchaseOrders.module";
import stockReceipts from "./stock/stockReceipts.module";
import stockReceivingSessions from "./stock/stockReceivingSessions.module";
import stockSalesOrders from "./stock/stockSalesOrders.module";
import stockSales from "./stock/stockSales.module";
import stockWriteOffs from "./stock/stockWriteOffs.module";
import stockTransfers from "./stock/stockTransfers.module";
import stockTransferOrders from "./stock/stockTransferOrders.module";
import stockMovements from "./stock/stockMovements.module";
import stockProductMovements from "./stock/stockProductMovements.module";
import stockTransportOrders from "./stock/stockTransportOrders.module";
import stockShipments from "./stock/stockShipments.module";
import stockInvoices from "./stock/stockInvoices.module";
import stockRevisions from "./stock/stockRevisions.module";
import stockDeliveryNotes from "./stock/stockDeliveryNotes.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        htmlClass,
        config,
        breadcrumbs,
        snack,
        selectsData,
        displayPreferences,
        companyContact,
        tagCategory,
        vendorOffer,
        vendorOfferSet,
        vendorOfferSetImportType,
        emailOffer,
        validationRule,
        tagCategoryType,
        quickOffer,
        users,
        teams,
        userFilter,
        aliases,
        mappings,
        mappingValues,
        incoterms,
        countries,
        transportData,
        liveList,
        priceLists,
        pricing,
        unit_conversions,
        price_config,
        companies,
        organizations,
        pipelines,
        deals,
        dealCustomerRequests,
        dealStatuses,
        dealDocumentTypes,
        dealTypes,
        fieldTagTypes,
        fieldTags,
        stockContext,
        stockWarehouses,
        stockProducts,
        stockProductCategories,
        stockProductDepartments,
        stockPackagings,
        stockUnits,
        stockInventory,
        stockDashboard,
        stockQualityHolds,
        stockAverageCosts,
        stockPurchaseOrders,
        stockReceipts,
        stockReceivingSessions,
        stockSalesOrders,
        stockSales,
        stockWriteOffs,
        stockTransfers,
        stockTransferOrders,
        stockMovements,
        stockProductMovements,
        stockTransportOrders,
        stockShipments,
        stockInvoices,
        stockRevisions,
        stockDeliveryNotes,
    }
});
